import { useState } from 'react';
import type { InstrumentDto } from '../../shared/types';
import { assetLogoSources } from '../logos';

export function AssetAvatar({ instrument }: { instrument: InstrumentDto }) {
  const symbol = instrument.symbol.toUpperCase();
  const sources = assetLogoSources(instrument);
  const [failedSources, setFailedSources] = useState<ReadonlySet<string>>(() => new Set());
  const src = sources.find((candidate) => !failedSources.has(candidate));
  const showLogo = Boolean(src);
  return <span className={`asset-avatar asset-${instrument.kind.toLowerCase()}${showLogo ? ' asset-logo' : ''}`} aria-hidden="true">
    {src ? <img src={src} alt="" width={32} height={32} loading="lazy" decoding="async"
      onError={() => setFailedSources((current) => new Set(current).add(src))} /> : symbol.slice(0, 2)}
  </span>;
}
